'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import { useMostlyInView } from '../use-animation-clock';
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
export const showcaseIconPaths = {
  plus: <path d={'M10 4.5v11M4.5 10h11'} />,
  mic: (
    <React.Fragment>
      <rect x={'7.5'} y={'3'} width={'5'} height={'9'} rx={'2.5'} />
      <path d={'M5 9.5a5 5 0 0 0 10 0M10 14.5V17'} />
    </React.Fragment>
  ),
  arrowUp: <path d={'M10 15.5v-11M5.5 9 10 4.5 14.5 9'} />,
  arrowRight: <path d={'M4.5 10h11M11 5.5l4.5 4.5-4.5 4.5'} />,
  wave: <path d={'M5 8.5v3M8 6v8M11 4.5v11M14 7v6M17 9v2M2 9.5v1'} />,
  chevronDown: <path d={'m6 8 4 4 4-4'} />,
  chevronRight: <path d={'m8 6 4 4-4 4'} />,
  compass: (
    <React.Fragment>
      <circle cx={'10'} cy={'10'} r={'7'} />
      <path d={'m12.8 7.2-1.6 4-4 1.6 1.6-4z'} />
    </React.Fragment>
  ),
  panel: (
    <React.Fragment>
      <rect x={'3.5'} y={'4'} width={'13'} height={'12'} rx={'2.5'} />
      <path d={'M8 4v12'} />
    </React.Fragment>
  ),
  speaker: <path d={'M4 8h2.5L10 5v10l-3.5-3H4zM13 7.5a3.5 3.5 0 0 1 0 5'} />,
  nodes: (
    <React.Fragment>
      <circle cx={'10'} cy={'5'} r={'2'} />
      <circle cx={'5'} cy={'14.5'} r={'2'} />
      <circle cx={'15'} cy={'14.5'} r={'2'} />
      <path d={'M9 6.7 6 12.8M11 6.7l3 6.1M7 14.5h6'} />
    </React.Fragment>
  ),
  check: <path d={'m5 10.5 3.2 3.2L15 6.8'} />,
  folder: (
    <path
      d={
        'M3.5 6.5a2 2 0 0 1 2-2h3l1.5 1.8h4.5a2 2 0 0 1 2 2v5.7a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2z'
      }
    />
  ),
  doc: (
    <React.Fragment>
      <path
        d={
          'M6 3.5h5.5L15 7v8.5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1z'
        }
      />
      <path d={'M11 3.5V7.5h4M7.5 11h5M7.5 13.5h3.5'} />
    </React.Fragment>
  ),
  sheet: (
    <React.Fragment>
      <rect x={'3.5'} y={'4'} width={'13'} height={'12'} rx={'1.5'} />
      <path d={'M3.5 8h13M3.5 12h13M8 4v12'} />
    </React.Fragment>
  ),
  deck: (
    <React.Fragment>
      <rect x={'3'} y={'4.5'} width={'14'} height={'9'} rx={'1.5'} />
      <path d={'M10 13.5V16M7 16.5h6'} />
    </React.Fragment>
  ),
  cube: (
    <React.Fragment>
      <path d={'M10 3 16 6.5v7L10 17l-6-3.5v-7z'} />
      <path d={'M4 6.5 10 10l6-3.5M10 10v7'} />
    </React.Fragment>
  ),
  play: <path d={'M7.5 5.5v9l7-4.5z'} />,
  pause: <path d={'M7.5 5.5v9M12.5 5.5v9'} />,
  replay: <path d={'M4.5 10a5.5 5.5 0 1 0 1.7-4M4.5 4.5V8H8'} />,
  image: (
    <React.Fragment>
      <rect x={'3.5'} y={'4'} width={'13'} height={'12'} rx={'2'} />
      <circle cx={'8'} cy={'8.5'} r={'1.3'} />
      <path d={'m3.5 14 4-3.5 3 2.5 2.5-2 3.5 3'} />
    </React.Fragment>
  ),
  clipboard: (
    <React.Fragment>
      <rect x={'5'} y={'4.5'} width={'10'} height={'12'} rx={'1.5'} />
      <path d={'M8 3.5h4v2H8zM7.5 9.5h5M7.5 12.5h3.5'} />
    </React.Fragment>
  ),
  layers: (
    <path
      d={'M10 3.5 17 7l-7 3.5L3 7zM3 10.5 10 14l7-3.5M3 13.5 10 17l7-3.5'}
    />
  ),
  swatch: (
    <React.Fragment>
      <path d={'M4 15.5 8.5 4.5l3.5 1.4-4.5 11z'} />
      <path d={'m11 7.5 4.6 1.9-3 7.1H8'} />
    </React.Fragment>
  ),
  lock: (
    <React.Fragment>
      <rect x={'4.5'} y={'9'} width={'11'} height={'8'} rx={'2'} />
      <path d={'M7 9V7a3 3 0 0 1 6 0v2'} />
    </React.Fragment>
  ),
  hash: <path d={'M8 3.5 6.5 16.5M13.5 3.5 12 16.5M4 7.5h12.5M3.5 12.5H16'} />,
  clock: (
    <React.Fragment>
      <circle cx={'10'} cy={'10'} r={'7'} />
      <path d={'M10 6v4l2.5 2'} />
    </React.Fragment>
  ),
  store: <path d={'M4 8v8h12V8M3 4.5h14l1 3.5H2zM8 16v-4h4v4'} />,
  mail: (
    <React.Fragment>
      <rect x={'3'} y={'5'} width={'14'} height={'10'} rx={'2'} />
      <path d={'m3.5 6 6.5 5 6.5-5'} />
    </React.Fragment>
  ),
  at: (
    <React.Fragment>
      <circle cx={'10'} cy={'10'} r={'3'} />
      <path d={'M13 10v1.2a2.3 2.3 0 0 0 4.5 0V10a7.5 7.5 0 1 0-3 6'} />
    </React.Fragment>
  ),
  megaphone: <path d={'M4 8v4h2.5L13 15.5v-11L6.5 8zM6.5 12l1 4.5M15.5 8v4'} />,
  users: (
    <React.Fragment>
      <circle cx={'7.5'} cy={'7.5'} r={'2.5'} />
      <path
        d={
          'M3 16a4.5 4.5 0 0 1 9 0M13 5.2a2.5 2.5 0 0 1 0 4.6M14.5 12.2A4.5 4.5 0 0 1 17 16'
        }
      />
    </React.Fragment>
  ),
  pen: <path d={'m12.5 4.5 3 3-8.5 8.5H4v-3zM11 6l3 3'} />,
  x: <path d={'M5.5 5.5l9 9M14.5 5.5l-9 9'} />,
  link: (
    <path
      d={
        'M8.5 11.5a3 3 0 0 0 4.2 0l2.3-2.3a3 3 0 0 0-4.2-4.2l-.8.8M11.5 8.5a3 3 0 0 0-4.2 0L5 10.8A3 3 0 0 0 9.2 15l.8-.8'
      }
    />
  ),
  search: (
    <React.Fragment>
      <circle cx={'9'} cy={'9'} r={'5'} />
      <path d={'m13 13 3.5 3.5'} />
    </React.Fragment>
  ),
  ruler: (
    <React.Fragment>
      <path d={'M3.5 13.5 13.5 3.5l3 3-10 10z'} />
      <path d={'m6.5 10.5 1.5 1.5M9 8l1.5 1.5M11.5 5.5 13 7'} />
    </React.Fragment>
  ),
  tag: (
    <React.Fragment>
      <path d={'M3.5 4.5v5l7 7 6-6-7-7h-5a1 1 0 0 0-1 1z'} />
      <circle cx={'7'} cy={'7'} r={'1'} />
    </React.Fragment>
  ),
  camera: (
    <React.Fragment>
      <path
        d={
          'M3.5 7a1.5 1.5 0 0 1 1.5-1.5h2L8.5 4h3L13 5.5h2A1.5 1.5 0 0 1 16.5 7v7a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 14z'
        }
      />
      <circle cx={'10'} cy={'10.5'} r={'2.7'} />
    </React.Fragment>
  ),
  zap: <path d={'M11 3 4.5 11.5H10L9 17l6.5-8.5H10z'} />,
  sun: (
    <React.Fragment>
      <circle cx={'10'} cy={'10'} r={'3.2'} />
      <path
        d={
          'M10 3v1.5M10 15.5V17M3 10h1.5M15.5 10H17M5 5l1 1M14 14l1 1M5 15l1-1M14 6l1-1'
        }
      />
    </React.Fragment>
  ),
  moon: <path d={'M15.5 12.3A6.2 6.2 0 0 1 7.7 4.5a6.2 6.2 0 1 0 7.8 7.8Z'} />,
};
export function withPathLengths(e) {
  let t = (e) =>
    React.isValidElement(e)
      ? React.cloneElement(e, {
          pathLength: 1,
        })
      : e;
  return React.isValidElement(e) && e.type === React.Fragment
    ? React.Children.map(e.props.children, t)
    : t(e);
}
export function ShowcaseIcon({
  name: e,
  className: t = 'size-4',
  strokeWidth: n = 1.5,
  draw: r,
  style: i,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <svg
      viewBox={'0 0 20 20'}
      fill={'none'}
      stroke={'currentColor'}
      strokeWidth={n}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      aria-hidden={!0}
      className={`${r === 'now' ? 'draw-now' : r === 'in-view' ? 'draw' : ''} ${t}`}
      style={i}
    >
      {translateShowcaseNode(
        showcaseCopy,
        r ? withPathLengths(showcaseIconPaths[e]) : showcaseIconPaths[e]
      )}
    </svg>
  );
}
export function ProductRender({
  render: e,
  className: t = '',
  imgClassName: n = '',
  alt: r,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let i = e.src.includes('/marketing/showcase/product/shared/direction-');
  return (
    <span className={`relative block overflow-hidden ${t}`}>
      <img
        src={e.src}
        alt={translateShowcaseNode(showcaseCopy, r ?? e.alt)}
        width={e.width}
        height={e.height}
        loading={'lazy'}
        decoding={'async'}
        className={`block size-full object-cover ${i ? 'origin-top scale-[1.085]' : ''} ${n}`}
      />
      <span
        aria-hidden={!0}
        className={
          'pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_0_0_0_1px_var(--img-outline)]'
        }
      />
    </span>
  );
}
export function useReveal({
  once: e = !1,
  rootMargin: t = '0px 0px -10% 0px',
} = {}) {
  let n = React.useRef(null),
    [r, i] = React.useState(null);
  return (
    React.useEffect(() => {
      let r = n.current;
      if (!r) return;
      let a = new IntersectionObserver(
        ([t]) => {
          t && (i(t.isIntersecting), t.isIntersecting && e && a.disconnect());
        },
        {
          rootMargin: t,
        }
      );
      return (a.observe(r), () => a.disconnect());
    }, [e, t]),
    [n, r]
  );
}
export const oe = [0, 0.2, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
export function SceneNotifications({
  toasts: e,
  className: t = '',
  label: n = 'Notifications',
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = e.length;
  return (
    <ol
      aria-label={translateShowcaseNode(showcaseCopy, n)}
      aria-live={'polite'}
      className={`toasts ${t}`}
    >
      {translateShowcaseNode(
        showcaseCopy,
        e.map((e, t) => {
          let n = r - 1 - t;
          return (
            <li
              key={e.id}
              className={'toast'}
              data-gone={n > 2}
              data-front={n === 0}
              style={{
                '--i': String(n),
              }}
            >
              <div className={'toast-card'}>
                <ShowcaseIcon
                  name={e.icon}
                  className={'text-ink mr-1 -ml-[3px] size-4 shrink-0'}
                />
                <span className={'min-w-0 flex-1'}>
                  <span className={'text-ink block truncate font-medium'}>
                    {translateShowcaseNode(showcaseCopy, e.title)}
                  </span>
                  {translateShowcaseNode(
                    showcaseCopy,
                    e.meta ? (
                      <span className={'text-ink-3 block truncate'}>
                        {translateShowcaseNode(showcaseCopy, e.meta)}
                      </span>
                    ) : null
                  )}
                </span>
              </div>
            </li>
          );
        })
      )}
    </ol>
  );
}
export { useMostlyInView };
